module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/AT-SPG-tiny.f13a2bd0.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/AT-SPG-tiny.png
// module id = 2711
// module chunks = 11